export default {
    items: [
        {
            name: 'Personal data',
            url: '/user/personal-data/info',
        },
        {
            name: 'Transactions',
            url: '/user/transactions/select',
        },
    ]
};



// WEBPACK FOOTER //
// ./src/components/Menu/_nav.js